import React from 'react';
import styled from 'styled-components';
import {Box, Image, useTheme} from '@chakra-ui/react';

import angleLeft from '../../assets/images/angle-left.png';
import {useBannerHeight} from '../../hooks/useTopBarOffset';

const Circle = styled(Box)`
  height: 2.2rem;
  width: 2.2rem;
  border-radius: 50%;
  display: inline-block;
`;

const StyledImage = styled(Image)`
  width: auto;
  height: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
`;

const StickyWrapper = styled(Box)<{$topOffset: number}>`
  position: fixed;
  top: ${props => props.$topOffset}px;
  left: 0px;
  z-index: 1001;
`;

function BackButton({onClick, type = 'white', sticky = true, ...props}) {
  const theme = useTheme();
  const bannerHeight = useBannerHeight();

  const background =
    type === 'grey' ? theme.colors.lightestGrey : type === 'transparent' ? 'transparent' : 'white';

  const border = type === 'transparent' ? 'unset' : `1px solid ${theme.colors.lightestGrey}`;

  const circleButton = (
    <Circle
      zIndex="1"
      position="relative"
      {...props}
      background={background}
      border={border}
      onClick={onClick}>
      <StyledImage src={angleLeft} alt="Arrow left" w={'1rem'} h={'1rem'} />
    </Circle>
  );

  // Wrap in sticky container if sticky prop is true
  return sticky ? <StickyWrapper $topOffset={bannerHeight}>{circleButton}</StickyWrapper> : circleButton;
}

export default BackButton;
